import React from 'react'

export const CoursesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.9869 5.28591V10.4286M4.19663 7.42871V10.4286C4.19663 11.1106 4.70196 11.7646 5.60145 12.2469C6.50094 12.7291 7.72091 13 8.99298 13C10.2651 13 11.485 12.7291 12.3845 12.2469C13.284 11.7646 13.7893 11.1106 13.7893 10.4286V7.42871M16.5233 6.07618C16.6664 6.00849 16.7878 5.89727 16.8725 5.7563C16.9573 5.61534 17.0016 5.45081 17 5.28311C16.9983 5.11542 16.9509 4.95191 16.8634 4.81285C16.776 4.67379 16.6524 4.56529 16.5081 4.50079L9.65648 1.15459C9.44819 1.05272 9.22192 1 8.99298 1C8.76405 1 8.53778 1.05272 8.32949 1.15459L1.47869 4.49736C1.33638 4.56419 1.21531 4.67404 1.13029 4.81348C1.04528 4.95292 1 5.11589 1 5.28248C1 5.44907 1.04528 5.61205 1.13029 5.75149C1.21531 5.89092 1.33638 6.00077 1.47869 6.06761L8.32949 9.41723C8.53778 9.5191 8.76405 9.57182 8.99298 9.57182C9.22192 9.57182 9.44819 9.5191 9.65648 9.41723L16.5233 6.07618Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
